import { useCallback, useState } from "react";
import useDashboardsTableHeader from "../../../hooks/useDashboardsTableHeader";
import BuildWorkflowModal from "./BuildWorkflowModal";
// import ManageCustomFieldsModal from "./ManageCustomFieldsModal";
import { FolderManagementModal } from "../folders/FolderManagementModal";
import ManageCustomFieldsNewModal from "./ManageCustomFieldsNewModal";
import ManageCustomTagsModal from "./ManageCustomTagsModal";
import ManageKeyPeopleTagsModal from "./ManageKeyPeopleTagsModal";
import ManageStagesModal from "./ManageStagesModal";
import ManageStatusModal from "./ManageStatusModal";
import ManageTagsModal from "./ManageTagsModal";

const ManageFieldsLoaderModal: React.FC<{
    open: boolean,
    recentType?: string,
    onClose: () => void,
}> = ({ open, recentType, onClose }) => {
    const {
        manageStatusModalOpen,
        manageTagsModalOpen,
        manageStagesModalOpen,
        manageKeyPeopleTagsModalOpen,
        manageCustomFieldsModalOpen,
        manageFieldsModalOpen,
        manageFoldersModalOpen,
        setManageStatusModalOpen,
        setManageTagsModalOpen,
        setManageStagesModalOpen,
        setManageKeyPeopleTagsModalOpen,
        setManageCustomFieldsModalOpen,
        setManageFieldsModalOpen,
        setManageFoldersModalOpen,
        handleEdit,
    } = useDashboardsTableHeader();

    //eslint-disable-next-line
    const [field, setField] = useState<string | undefined>(undefined);
    const [initialFieldName, setInitialFieldName] = useState<string | undefined>(undefined);

    const handleModalOpen = useCallback((field?: string) => {
        const newFieldMatch = field?.match(/\[\[new-(\w+?)(?::(.+?))?\]\]/);
        if (!!field && !newFieldMatch) {
            setField(field);
            setInitialFieldName(undefined);
        } else if (newFieldMatch) {
            setField(undefined);
            setInitialFieldName(newFieldMatch[2] || undefined);
        }
        handleEdit(field);
    }, [handleEdit]);

    return (<>
        <BuildWorkflowModal
            open={open}
            recentType={recentType}
            onOpenModal={handleModalOpen}
            onClose={onClose}
        />
        {manageTagsModalOpen && (
            <ManageTagsModal
                open={false}
                filterType={field}
                onClose={() => setManageTagsModalOpen(false)} />
        )}
        {manageTagsModalOpen && (
            <ManageCustomTagsModal
                open={manageTagsModalOpen}
                filterType={field}
                initialName={initialFieldName}
                onClose={() => setManageTagsModalOpen(false)}
            />
        )}
        {manageStagesModalOpen && (
            <ManageStagesModal
                open={manageStagesModalOpen}
                onClose={() => setManageStagesModalOpen(false)} />
        )}
        {manageKeyPeopleTagsModalOpen && (
            <ManageKeyPeopleTagsModal
                open={manageKeyPeopleTagsModalOpen}
                onClose={() => setManageKeyPeopleTagsModalOpen(false)} />
        )}
        {manageCustomFieldsModalOpen && (
            <ManageCustomFieldsNewModal
                open={manageCustomFieldsModalOpen}
                filterType={field}
                initialName={initialFieldName}
                onClose={() => setManageCustomFieldsModalOpen(false)} />
        )}
        {manageStatusModalOpen && (
            <ManageStatusModal
                open={manageStatusModalOpen}
                onClose={() => setManageStatusModalOpen(false)} />
        )}
        {manageFieldsModalOpen && (
            <ManageFieldsLoaderModal
                open={manageFieldsModalOpen}
                onClose={() => setManageFieldsModalOpen(false)} />
        )}
        {manageFoldersModalOpen && (
            <FolderManagementModal
                open={manageFoldersModalOpen}
                onClose={() => setManageFoldersModalOpen(false)}
            />
        )}
    </>);
}

export default ManageFieldsLoaderModal;